import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import { MarketplaceIds } from '../../../enums/marketplace-ids';
import Global from '../../../store/global-selectors';
import NotificationEmailsGraph from '../components/graphs/notification-email-graph';
import InsufficientDataBannerMessage from '../components/insufficient-data-banner-message';

import messages from './messages';
import style from './style.module.less';
import { BASE_STORE_SETUP_URL } from '../../../routes/constants';

const CustomerEngagement = ({ chartData = emptyObject, selectedStore }) => {
  const { email, deliveryEmail } = chartData;
  const stores = useSelector(Global.selectSellerStores);
  const filteredStores = useMemo(
    () => stores.filter((store) => store.isActive && store.marketplaceId !== MarketplaceIds.AuctaneFulfillment),
    [stores],
  );
  const { shouldShowShipmentNotificationChart, shouldShowDeliveryNotificationChart } = useMemo(
    () => ({
      shouldShowShipmentNotificationChart: Boolean(
        selectedStore ? selectedStore?.shipmentEmailTemplate : filteredStores.some((store) => store?.shipmentEmailTemplate),
      ),
      shouldShowDeliveryNotificationChart: Boolean(
        selectedStore ? selectedStore?.deliveryEmailTemplate : filteredStores.some((store) => store?.deliveryEmailTemplate),
      ),
    }),
    [selectedStore, filteredStores],
  );
  const storeSetupLink = selectedStore ? `${BASE_STORE_SETUP_URL}/${selectedStore.storeGuid}` : BASE_STORE_SETUP_URL;

  return (
    <>
      {!email?.processed && !deliveryEmail?.processed && <InsufficientDataBannerMessage />}
      <div className={style.container}>
        <div className={style['chart-section']}>
          <h2 className={style.title}>
            <FormattedMessage {...messages.shipmentNotificationEmailsTitle} />
          </h2>
          {shouldShowShipmentNotificationChart ? (
            <NotificationEmailsGraph data={email} store={selectedStore} />
          ) : (
            <p className={style['helper-message']}>
              <FormattedMessage
                {...messages.turnOnShipmentNotificationEmailsMessage}
                values={{
                  link: (chunks) => <Link to={storeSetupLink}>{chunks}</Link>,
                }}
              />
            </p>
          )}
        </div>
        <div className={style['chart-section']}>
          <h2 className={style.title}>
            <FormattedMessage {...messages.deliveryNotificationEmailsTitle} />
          </h2>
          {shouldShowDeliveryNotificationChart ? (
            <NotificationEmailsGraph data={deliveryEmail} store={selectedStore} />
          ) : (
            <p className={style['helper-message']}>
              <FormattedMessage
                {...messages.turnOnDeliveryNotificationEmailsMessage}
                values={{
                  link: (chunks) => <Link to={storeSetupLink}>{chunks}</Link>,
                }}
              />
            </p>
          )}
        </div>
      </div>
    </>
  );
};

CustomerEngagement.propTypes = {
  chartData: PropTypes.object,
  selectedStore: PropTypes.object,
};

export default CustomerEngagement;
